import {Component, Input} from '@angular/core';
import {FullscreenService} from 'fuse-core/services/fullscreen.service';

import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';

// TODO ce composant n'est pas au bon endroit, dans ce dossier il y a des composants qui sont utilisés pour executer un typologies, ce composant n'a rien a faire ici

@Component({
    selector: 'app-zoomable',
    templateUrl: './zoomable.component.html',
    styleUrls: ['./zoomable.component.scss'],
    imports: [
    MatIconModule,
    MatTooltipModule,
    TranslateModule
]
})
export class ZoomableComponent {

    @Input() index: number;
    @Input() uuid: string;

    constructor(public fullscreenService: FullscreenService) {
    }

    /**
     * ref of the img to zoom by default is 'imgToZoom'
     * the index value is use when there is multiple img in an activity
     * the uuid is necessary for summary to be sure to add only one id by img when there's multiple one
     */
    get target(): string {
        let target = 'imgToZoom';
        if (this.uuid) {
            target = target + this.uuid;
        }
        if (this.index >= 0) {
            target = target + this.index.toString();
        }
        return target;
    }

}
